import postAPI from './postAPI.js'

export default async function postAddInstanceStep(body) {
    const data = await postAPI('admin/taskinstances/steps/add', body);
    return data;
}
